import { render, staticRenderFns } from "./ProposalButtonLink.vue?vue&type=template&id=17684669&scoped=true"
import script from "./ProposalButtonLink.vue?vue&type=script&lang=js"
export * from "./ProposalButtonLink.vue?vue&type=script&lang=js"
import style0 from "./ProposalButtonLink.vue?vue&type=style&index=0&id=17684669&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17684669",
  null
  
)

export default component.exports